import { render, staticRenderFns } from "./MarkManage.vue?vue&type=template&id=49857777&scoped=true&"
import script from "./MarkManage.vue?vue&type=script&lang=js&"
export * from "./MarkManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49857777",
  null
  
)

export default component.exports